var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"button",staticClass:"share-button"},[_vm._t("default",null,{"onClick":_vm.onClick,"loading":_vm.loading})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }